import ClearingAPI from '@shared/api';

export const {
    transactions: { get: getTransactions },
    securities: { getLogo },
} = ClearingAPI.settings;
